import type { SourceSpecification } from 'maplibre-gl';

// A map sources object with no data that fulfils the requirements.
export const blankMapSource: { protomaps: SourceSpecification } = {
    protomaps: {
        type: 'geojson',
        data: {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Point',
                coordinates: [0, 0],
            },
        },
    },
};

// A blank layer that will be used for clustering.
export const clusterMapSource = {
    pins: {
        type: 'geojson',
        cluster: true,
        clusterRadius: 200,
        maxzoom: 16,
        data: {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Point',
                coordinates: [0, 0],
            },
        },
    },
} satisfies { pins: SourceSpecification };

// A blank layer that will be used to display areas that represent map items.
export const mapItemAreasMapSource: { mapItemAreas: SourceSpecification } = {
    mapItemAreas: {
        type: 'geojson',
        data: {
            type: 'Feature',
            properties: {},
            geometry: {
                type: 'Polygon',
                coordinates: [],
            },
        },
    },
};
